var React = require('react');

function AddIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"square","strokeWidth":"2","transform":"translate(1 1)"},[React.createElement("path",{"d":"M21 40H0V0h40v21","key":0}),React.createElement("circle",{"cx":"15","cy":"10","r":"4","key":1}),React.createElement("circle",{"cx":"35","cy":"35","r":"9","key":2}),React.createElement("path",{"d":"M35 32v6M32 35h6M7 30l8-10 8 6 10-12","key":3})]));
}

AddIcon.defaultProps = {"width":"46","height":"46","viewBox":"0 0 46 46","stroke":"#62727A"};

module.exports = AddIcon;

AddIcon.default = AddIcon;
